import React from "react";
import {storage} from "../firebase";
import {FetchStatisticData} from "./FetchStatisticData";

//Resets the data for student assignments
//Doesn't delete existing student names
export function HandleClearQuizData(classLevel, assignment, assignmentNum){
    let promise = new Promise((resolve)=>{
        FetchStatisticData(classLevel, 'quizAssignments').then((res)=>{
            //for each student in the quiz data, reset all their assignments to 0
            for(let i = 0; i < res.length; i++){
                for(let n = 0; n < res[i].assignmentCompletion[assignmentNum].length; n++){
                    res[i].assignmentCompletion[assignmentNum][n] = 0;
                    res[i].attempts[assignmentNum][n] = 0;
                    res[i].hint[assignmentNum][n] = 0;

                }
                res[i].date[assignmentNum] = "";
            }
            resolve(res)
            let newStudentData = res;
            const JSONobj = JSON.stringify(newStudentData);
            const blobObj = new Blob([JSONobj], {type: "application/json"});
            const uploadTask = storage.ref('students/10' + classLevel + '/quizData.json').put(blobObj);
            uploadTask.on(
                "state_changed",
                () => {
                },
                error => {
                    console.log(error)
                },
                () => {
                    storage
                        .ref('students/10' + classLevel)
                        .child('quizData.json')
                        .getDownloadURL()
                        .then(url => {
                                console.log(url);
                            }
                        )
                        .catch(e => console.log(e));
                }
            )
        })
    });
    return promise;
}
